module.exports = __webpack_public_path__ + "static/media/background-2.19efa399.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/background-2.jpg
// module id = 277
// module chunks = 0